import * as React from "react";
import { Paper, Grid, Select, MenuItem } from "@material-ui/core";
import TypographyInfo from "Components/Typography/typography-info";
import TypographySubinfo from "Components/Typography/typography-subinfo";
import moment from "moment";
import {
  faCalendar,
  faDiceD6,
  faMobileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { IDeviceListItemProps } from "Components/Device/interfaces-device";
import { stylesDeviceListItem } from "Components/Device/DeviceList/styles";
import DeviceApi from "Services/Api/device-api";
import ProgressSpinner from "Components/ProgressSpinner/progress-spinner";
import { AppVersionNumberType } from "Types/device-types";
import { AxiosError } from "axios";
import ErrorDialog from "Components/Dialogs/ErrorDialog/error-dialog";

const deviceApi = new DeviceApi();

export default function DeviceListItem(props: IDeviceListItemProps) {
  const customStyles = stylesDeviceListItem({});
  const { device } = props;
  const [isBlockedUi, setIsBlockedUi] = React.useState(false);
  const [errorResponse, setErrorResponse] = React.useState<AxiosError | null>(null);
  const [selectedForceUpdateVersionId, setSelectedForceUpdateVersionId] = React.useState<number | null>(device.forceUpdateToIAMobileAppVersionID);

  const handleForceUpdateVersionChange = async (
      event: React.ChangeEvent<{ value: unknown }>
    ): Promise<void> => {
      let selectedValue: number = Number(event.target.value as string);
      let newSelectedForceUpdateVersionId: number | null = selectedValue !== -1 ? selectedValue : null;
  
      setIsBlockedUi(true);
      await deviceApi
        .saveMobileAppDeviceSettings({
          iaDeviceID: device.id,
          forceUpdateToIAMobileAppVersionID: newSelectedForceUpdateVersionId,
        })
        .then(result => {
          setSelectedForceUpdateVersionId(newSelectedForceUpdateVersionId);
        })
        .catch((error) => {
          console.error(error);
          setErrorResponse(error);
        })
        .finally(() => {
          setIsBlockedUi(false);
        });
    };
  
  const handleErrorDialogOkClick = (
      event: React.MouseEvent<HTMLButtonElement>
    ): void => {
      setErrorResponse(null);
    };
    
  return (
    <tr>
      <td>
        <React.Fragment>
          <ProgressSpinner isDisplayed={isBlockedUi}>
            <Paper className={customStyles.paper}>
              <Grid container alignItems="center">
                <Grid container item xs={3}>
                  <Grid container item xs={12} className={customStyles.gridItem}>
                    <Grid container item sm={12}>
                      <Grid item sm={device.locationKey ? 10 : 12}>
                        <TypographyInfo text={device.name} />
                      </Grid>
                      {device.locationKey && <Grid item sm={2}>
                        <TypographyInfo text={device.locationKey} />
                      </Grid>}
                    </Grid>
                    <Grid item sm={12}>
                      <TypographySubinfo text={device.serialNo} />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container item sm={9}>
                  <Grid item sm={2}>
                    <TypographySubinfo
                      text={moment.utc(device.lastContactDateUTC).local().format("DD/MM/YYYY")}
                      iconStart={faCalendar}
                    />
                  </Grid>
                  <Grid item sm={2}>
                    <TypographySubinfo text={device.osInfo} iconStart={faDiceD6} />
                  </Grid>
                  <Grid item sm={2}>
                    <TypographySubinfo
                      text={`Release ${device.mobileAppVersionNo}`}
                      iconStart={faMobileAlt}
                    />
                  </Grid>
                  {props.appVersionNumberList?.some(v => Number(v.versionNo) > Number(device.mobileAppVersionNo)) &&
                  <Grid container item sm={6}>
                    <Grid item sm={3}>
                      <TypographySubinfo text={"Force update to"}/>
                    </Grid>
                    <Grid item>
                      <Select
                        value={selectedForceUpdateVersionId ?? -1}
                        onChange={handleForceUpdateVersionChange}
                        renderValue={(selected) => {
                          let selectedVersion: AppVersionNumberType | undefined = props.appVersionNumberList.find(v => v.id.toString() === selected?.toString());
                          let versionNo: string = selectedVersion ? `Release ${selectedVersion.versionNo}` : "disabled";
                          return (<TypographySubinfo text={versionNo}/>);
                        }}
                      >
                        <MenuItem key={null} value={-1}>disabled</MenuItem>
                        {props.appVersionNumberList
                          .filter(v => Number(v.versionNo) > Number(device.mobileAppVersionNo))
                          .map(v => (
                            <MenuItem key={v.id} value={v.id.toString()}>
                              {`Release ${v.versionNo}`}
                            </MenuItem>
                          ))}
                      </Select>
                    </Grid>
                  </Grid>}
                </Grid>
              </Grid>
            </Paper>
          </ProgressSpinner>
          <ErrorDialog
            isOpen={!!errorResponse}
            error={errorResponse}
            handleOkClick={handleErrorDialogOkClick}
          />
        </React.Fragment>
      </td>
    </tr>
  );
}
